
  
  <div class="container">
    <div data-app="true" class="v-application v-application--is-ltr theme--light">
      <div class="v-application--wrap">
        <div class="inner">
          <div
            class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
          >
            <div class="v-input__control">
              <label for="email">メールアドレス</label>
              <div class="v-input__slot">
                <input
                  style="height: 100%"
                  (focus)="focus(inputState.email)"
                  (blur)="blur(inputState.email)"
                  [(ngModel)]="email"
                  id="email"
                  type="email"
                />
              </div>
              <div class="v-text-field__details">
                <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                <div class="v-messages theme--light error--text">
                  <div
                    *ngIf="errorMessages.login.email"
                    class="v-messages__wrapper"
                  >
                    {{ errorMessages.login.email }}
  
                    <!-- 注釈及びエラーテキストが入ります。 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
          <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
          <div
            class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
          >
            <div class="v-input__control">
              <label for="password">パスワード</label>
              <app-sgzp-app2password-input
                [(ngModel)]="password"
                name="confirm"
                placeholder="パスワード（再入力）"
              ></app-sgzp-app2password-input>
              <div class="v-text-field__details">
                <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                <div class="v-messages theme--light error--text">
                  <div
                    *ngIf="errorMessages.login.password"
                    class="v-messages__wrapper"
                  >
                    {{ errorMessages.login.password }}
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="text-center mb-6">
            <button
              (click)="login()"
              type="button"
              class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary full-width"
              medium=""
            >
              <span class="v-btn__content"> ログイン </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  